import SectorService from '../services/Sector.js';
import BenefitService from '../services/Benefit.js';
import DevelopmentStageService from '../services/DevelopmentStage.js';
import GeographicalAreaService from '../services/GeographicalArea.js';
import CountryService from '../services/Country.js';
import PatentStatusService from '../services/PatentStatus.js';
import CompanyTypeService from '../services/CompanyTypes.js';
import InvestmentTypeService from '../services/InvestmentTypes.js';
import CurrencyService from '../services/Currencies.js';
import Multiselect from 'vue-multiselect';
import InfiniteLoading from 'vue-infinite-loading';
import moment from 'moment';

if ($('#innovations-list-component').length) {
    var sprintf = require('sprintf-js').sprintf;
    var app = new Vue({
        el: '#innovations-list-component',
        data: {
            loading: true,
            firstLoad: true,
            sectors: [],
            sectorSlugs: [],
            innovations: [],
            page: 1,


            additionalSectorIds: [],
            countries: [],
            countryIds: [],
            developmentStages: [],
            developmentStageIds: [],
            benefits: [],
            benefitIds: [],
            patentStatuses: [],
            patentStatusIds: [],
            geographicalAreas: [],
            geographicalAreaIds: [],
            companyTypes: [],
            companyTypeIds: [],
            investmentTypes: [],
            investmentTypeIds: [],
            currencies: [],
            currencyIds: [],
            showAdditionalFilters: false,
            searchOptions: {
                sector: null,
                search: '',
                countries: [],
                geographicalAreas: [],
                developmentStages: [],
                benefits: [],
                patentStatuses: [],
                investmentTypes: [],
                companyTypes: [],
                currencies: [],
                additionalSectors: []
            },
            relatedInnovations: [],
            relatedLoading: false,
            ad: [],
            api_url: api_url
        },
        methods: {
            getInnovations($state) {
                let url = this.constructUrl();
                url = url + '&page=' + this.page;

                var scrollPosition = null;
                if (this.firstLoad && sessionStorage.scrollPos && sessionStorage.scrollPos != 0) {
                    scrollPosition = sessionStorage.scrollPos;
                }

                axios.get(this.api_url + '/api/v1' + url).then((response) => {
                    if (this.page == 1 && response.data.innovations.data.length) {
                        this.innovations = response.data.innovations.data;
                        this.innovations.splice(2, 0, null);
                    } else {
                        this.innovations.push.apply(this.innovations, response.data.innovations.data)
                    }

                    this.ad = response.data.ad;

                    if (response.data.innovations.current_page === response.data.innovations.last_page) {
                        this.getRelatedInnovations();
                    }

                    this.loading = false;
                    this.page++;
                    if (this.page > response.data.innovations.last_page) {
                        $state.complete();
                    } else {
                        $state.loaded();
                    }

                    if (this.firstLoad) {
                        this.$nextTick(() => {
                            if (scrollPosition) {
                                $(window).scrollTop(scrollPosition)
                            }
                        });
                    }

                    this.firstLoad = false;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getParameter(name, url = window.location.href) {
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            getSectorName(option) {
                let value = this.sectors.filter(obj => {
                    return obj.slug === option
                });

                return value[0].name;
            },
            debounceInput: _.debounce(function () {
                this.processSearch();
            }, 1000),
            constructUrl() {

                let url = '/innovations';

                if (sessionStorage.getItem("sector_innovation")) {
                    url = url + '/' + sessionStorage.getItem("sector_innovation");
                } else if (this.searchOptions.sector) {
                    url = url + '/' + this.searchOptions.sector;
                }

                if (this.searchOptions.search) {
                    url = url + '?search=' + this.searchOptions.search;
                } else {
                    url = url + '?search=';
                }

                if (sessionStorage.getItem("countries")) {
                    url = url + '&countries=' + encodeURIComponent(sessionStorage.getItem("countries"));
                } else if (this.searchOptions.countries && this.searchOptions.countries.length) {
                    url = url + '&countries=' + encodeURIComponent(JSON.stringify(this.searchOptions.countries));
                }

                if (sessionStorage.getItem("geographicalAreas")) {
                    url = url + '&geographicalAreas=' + encodeURIComponent(sessionStorage.getItem("geographicalAreas"));
                } else if (this.searchOptions.geographicalAreas && this.searchOptions.geographicalAreas.length) {
                    url = url + '&geographicalAreas=' + encodeURIComponent(JSON.stringify(this.searchOptions.geographicalAreas));
                }

                if (sessionStorage.getItem("benefits")) {
                    url = url + '&benefits=' + encodeURIComponent(sessionStorage.getItem("benefits"));
                } else if (this.searchOptions.benefits && this.searchOptions.benefits.length) {
                    url = url + '&benefits=' + encodeURIComponent(JSON.stringify(this.searchOptions.benefits));
                }

                if (sessionStorage.getItem("developmentStages")) {
                    url = url + '&developmentStages=' + encodeURIComponent(sessionStorage.getItem("developmentStages"));
                } else if (this.searchOptions.developmentStages && this.searchOptions.developmentStages.length) {
                    url = url + '&developmentStages=' + encodeURIComponent(JSON.stringify(this.searchOptions.developmentStages));
                }

                if (sessionStorage.getItem("patentStatuses")) {
                    url = url + '&patentStatuses=' + encodeURIComponent(sessionStorage.getItem("patentStatuses"));
                } else if (this.searchOptions.patentStatuses && this.searchOptions.patentStatuses.length) {
                    url = url + '&patentStatuses=' + encodeURIComponent(JSON.stringify(this.searchOptions.patentStatuses));
                }

                if (sessionStorage.getItem("companyTypes")) {
                    url = url + '&companyTypes=' + encodeURIComponent(sessionStorage.getItem("companyTypes"));
                } else if (this.searchOptions.companyTypes && this.searchOptions.companyTypes.length) {
                    url = url + '&companyTypes=' + encodeURIComponent(JSON.stringify(this.searchOptions.companyTypes));
                }

                if (sessionStorage.getItem("investmentTypes")) {
                    url = url + '&investmentTypes=' + encodeURIComponent(sessionStorage.getItem("investmentTypes"));
                } else if (this.searchOptions.investmentTypes && this.searchOptions.investmentTypes.length) {
                    url = url + '&investmentTypes=' + encodeURIComponent(JSON.stringify(this.searchOptions.investmentTypes));
                }

                if (sessionStorage.getItem("currencies")) {
                    url = url + '&currencies=' + encodeURIComponent(sessionStorage.getItem("currencies"));
                } else if (this.searchOptions.currencies && this.searchOptions.currencies.length) {
                    url = url + '&currencies=' + encodeURIComponent(JSON.stringify(this.searchOptions.currencies));
                }

                if (sessionStorage.getItem("additionalSectors")) {
                    url = url + '&additionalSectors=' + encodeURIComponent(sessionStorage.getItem("additionalSectors"));
                } else if (this.searchOptions.additionalSectors && this.searchOptions.additionalSectors.length) {
                    url = url + '&additionalSectors=' + encodeURIComponent(JSON.stringify(this.searchOptions.additionalSectors));
                }

                return url;
            },
            processSearch() {
                if (this.searchOptions.sector) {
                    sessionStorage.setItem("sector_innovation", this.searchOptions.sector);
                }
                if (this.searchOptions.countries && this.searchOptions.countries.length) {
                    sessionStorage.setItem("countries", JSON.stringify(this.searchOptions.countries));
                }
                if (this.searchOptions.geographicalAreas && this.searchOptions.geographicalAreas.length) {
                    sessionStorage.setItem("geographicalAreas", JSON.stringify(this.searchOptions.geographicalAreas));
                }
                if (this.searchOptions.currencies && this.searchOptions.currencies.length) {
                    sessionStorage.setItem("currencies", JSON.stringify(this.searchOptions.currencies));
                }
                if (this.searchOptions.benefits && this.searchOptions.benefits.length) {
                    sessionStorage.setItem("benefits", JSON.stringify(this.searchOptions.benefits));
                }
                if (this.searchOptions.developmentStages && this.searchOptions.developmentStages.length) {
                    sessionStorage.setItem("developmentStages", JSON.stringify(this.searchOptions.developmentStages));
                }
                if (this.searchOptions.patentStatuses && this.searchOptions.patentStatuses.length) {
                    sessionStorage.setItem("patentStatuses", JSON.stringify(this.searchOptions.patentStatuses));
                }
                if (this.searchOptions.investmentTypes && this.searchOptions.investmentTypes.length) {
                    sessionStorage.setItem("investmentTypes", JSON.stringify(this.searchOptions.investmentTypes));
                }
                if (this.searchOptions.companyTypes && this.searchOptions.companyTypes.length) {
                    sessionStorage.setItem("companyTypes", JSON.stringify(this.searchOptions.companyTypes));
                }
                if (this.searchOptions.additionalSectors && this.searchOptions.additionalSectors.length) {
                    sessionStorage.setItem("additionalSectors", JSON.stringify(this.searchOptions.additionalSectors));
                }

                this.innovations = [];
                this.page = 1;
                this.firstLoad = true;
                this.loading = true;
                this.$refs.infiniteLoading.stateChanger.reset();
            },
            truncate(str, n) {
                str.replace(/<\/?[^>]+(>|$)/g, "");
                return (str.length > n) ? str.substr(0, n - 1) + '&hellip;' : str;
            },
            getShortDescription(description) {
                return description.substr(0, 180);
            },
            getUpdateDate(date) {
                return moment(date).format('MMM DD, YYYY');
            },
            getRef(id) {
                return sprintf('%05d', id);
            },


            getCountryName(option) {
                let value = this.countries.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getGeographicalAreaName(option) {
                let value = this.geographicalAreas.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getDevelopmentStageName(option) {
                let value = this.developmentStages.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getBenefitName(option) {
                let value = this.benefits.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getPatentStatusName(option) {
                let value = this.patentStatuses.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getInvestmentTypeName(option) {
                let value = this.investmentTypes.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getCompanyTypeName(option) {
                let value = this.companyTypes.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getCurrencyName(option) {
                let value = this.currencies.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getAdditionalSectorName(option) {
                let value = this.sectors.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            checkForCurrentSearch() {
                if (
                    ((this.searchOptions.currencies && this.searchOptions.currencies.length > 0) || (sessionStorage.getItem("currencies") && JSON.parse(sessionStorage.getItem("currencies")).length > 0)) ||
                    ((this.searchOptions.investmentTypes && this.searchOptions.investmentTypes.length > 0) || (sessionStorage.getItem("investmentTypes") && JSON.parse(sessionStorage.getItem("investmentTypes")).length > 0)) ||
                    ((this.searchOptions.companyTypes && this.searchOptions.companyTypes.length > 0) || (sessionStorage.getItem("companyTypes") && JSON.parse(sessionStorage.getItem("companyTypes")).length > 0)) ||
                    ((this.searchOptions.geographicalAreas && this.searchOptions.geographicalAreas.length > 0) || (sessionStorage.getItem("geographicalAreas") && JSON.parse(sessionStorage.getItem("geographicalAreas")).length > 0)) ||
                    ((this.searchOptions.patentStatuses && this.searchOptions.patentStatuses.length > 0) || (sessionStorage.getItem("patentStatuses") && JSON.parse(sessionStorage.getItem("patentStatuses")).length > 0)) ||
                    ((this.searchOptions.developmentStages && this.searchOptions.developmentStages.length > 0) || (sessionStorage.getItem("developmentStages") && JSON.parse(sessionStorage.getItem("developmentStages")).length > 0)) ||
                    ((this.searchOptions.countries && this.searchOptions.countries.length > 0) || (sessionStorage.getItem("countries") && JSON.parse(sessionStorage.getItem("countries")).length > 0)) ||
                    ((this.searchOptions.benefits && this.searchOptions.benefits.length > 0) || (sessionStorage.getItem("benefits") && JSON.parse(sessionStorage.getItem("benefits")).length > 0)) ||
                    ((this.searchOptions.additionalSectors && this.searchOptions.additionalSectors.length > 0) || (sessionStorage.getItem("additionalSectors") && JSON.parse(sessionStorage.getItem("additionalSectors")).length > 0))
                ) {
                    this.showAdditionalFilters = true;
                    $('html, body').animate({scrollTop: $('#innovations-list-component').offset().top - 100}, 0);
                }
            },
            getRelatedInnovations() {
                this.relatedLoading = true;
                this.relatedInnovations = [];
                let ids = this.innovations.map(function (a) {
                    if (a) {
                        return a.id;
                    }
                });
                let sectors = this.innovations.map(function (a) {
                    if (a) {
                        return a.primary_sector_id;
                    }
                });
                ids = ids.filter(function (a) {
                    return a !== undefined;
                });
                sectors = sectors.filter(function (a) {
                    return a !== undefined;
                });

                axios.get(this.api_url + '/api/v1/related-innovations', {
                    'ids': ids,
                    'sectors': sectors
                }).then((response) => {
                    this.relatedInnovations = response.data
                    this.relatedLoading = false;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            removeSector(removedOption, id) {
                sessionStorage.removeItem("sector_innovation");
            },
            callServices() {
                if (this.benefitIds.length === 0) {
                    BenefitService.getBenefits().then(data => {
                        this.benefits = data;
                        this.benefitIds = this.benefits.map(a => a.id);
                        if (sessionStorage.getItem("benefits")) {
                            this.searchOptions.benefits = JSON.parse(decodeURIComponent(sessionStorage.getItem("benefits")));
                        } else {
                            this.searchOptions.benefits = JSON.parse(decodeURIComponent(this.getParameter('benefits')));
                        }
                        this.checkForCurrentSearch();
                    });
                    CountryService.getCountries().then(data => {
                        this.countries = data;
                        this.countryIds = this.countries.map(a => a.id);
                        if (sessionStorage.getItem("countries")) {
                            this.searchOptions.countries = JSON.parse(decodeURIComponent(sessionStorage.getItem("countries")));
                        } else {
                            this.searchOptions.countries = JSON.parse(decodeURIComponent(this.getParameter('countries')));
                        }
                        this.checkForCurrentSearch();
                    });
                    DevelopmentStageService.getDevelopmentStages().then(data => {
                        this.developmentStages = data;
                        this.developmentStageIds = this.developmentStages.map(a => a.id);
                        if (sessionStorage.getItem("developmentStages")) {
                            this.searchOptions.developmentStages = JSON.parse(decodeURIComponent(sessionStorage.getItem("developmentStages")));
                        } else {
                            this.searchOptions.developmentStages = JSON.parse(decodeURIComponent(this.getParameter('developmentStages')));
                        }
                        this.checkForCurrentSearch();
                    });
                    PatentStatusService.getPatentStatuses().then(data => {
                        this.patentStatuses = data;
                        this.patentStatusIds = this.patentStatuses.map(a => a.id);
                        if (sessionStorage.getItem("patentStatuses")) {
                            this.searchOptions.patentStatuses = JSON.parse(decodeURIComponent(sessionStorage.getItem("patentStatuses")));
                        } else {
                            this.searchOptions.patentStatuses = JSON.parse(decodeURIComponent(this.getParameter('patentStatuses')));
                        }
                        this.checkForCurrentSearch();
                    });
                    GeographicalAreaService.getGeographicalAreas().then(data => {
                        this.geographicalAreas = data;
                        this.geographicalAreaIds = this.geographicalAreas.map(a => a.id);
                        if (sessionStorage.getItem("geographicalAreas")) {
                            this.searchOptions.geographicalAreas = JSON.parse(decodeURIComponent(sessionStorage.getItem("geographicalAreas")));
                        } else {
                            this.searchOptions.geographicalAreas = JSON.parse(decodeURIComponent(this.getParameter('geographicalAreas')));
                        }
                        this.checkForCurrentSearch();
                    });
                    CompanyTypeService.getCompanyTypes().then(data => {
                        this.companyTypes = data;
                        this.companyTypeIds = this.companyTypes.map(a => a.id);
                        if (sessionStorage.getItem("companyTypes")) {
                            this.searchOptions.companyTypes = JSON.parse(decodeURIComponent(sessionStorage.getItem("companyTypes")));
                        } else {
                            this.searchOptions.companyTypes = JSON.parse(decodeURIComponent(this.getParameter('companyTypes')));
                        }
                        this.checkForCurrentSearch();
                    });
                    InvestmentTypeService.getInvestmentTypes().then(data => {
                        this.investmentTypes = data;
                        this.investmentTypeIds = this.investmentTypes.map(a => a.id);
                        if (sessionStorage.getItem("investmentTypes")) {
                            this.searchOptions.investmentTypes = JSON.parse(decodeURIComponent(sessionStorage.getItem("investmentTypes")));
                        } else {
                            this.searchOptions.investmentTypes = JSON.parse(decodeURIComponent(this.getParameter('investmentTypes')));
                        }
                        this.checkForCurrentSearch();
                    });
                    CurrencyService.getCurrencies().then(data => {
                        this.currencies = data;
                        this.currencyIds = this.currencies.map(a => a.id);
                        if (sessionStorage.getItem("currencies")) {
                            this.searchOptions.currencies = JSON.parse(decodeURIComponent(sessionStorage.getItem("currencies")));
                        } else {
                            this.searchOptions.currencies = JSON.parse(decodeURIComponent(this.getParameter('currencies')));
                        }
                        this.checkForCurrentSearch();
                    });
                    SectorService.getSectors().then(data => {
                        this.sectors = data;
                        this.additionalSectorIds = this.sectors.map(a => a.id);
                        if (sessionStorage.getItem("additionalSectors")) {
                            this.searchOptions.additionalSectors = JSON.parse(decodeURIComponent(sessionStorage.getItem("additionalSectors")));
                        } else {
                            this.searchOptions.additionalSectors = JSON.parse(decodeURIComponent(this.getParameter('additionalSectors')));
                        }
                        this.checkForCurrentSearch();
                    });
                }
            },
            callSectors() {
                if (this.sectorSlugs.length === 0) {
                    SectorService.getSectors().then(data => {
                        this.sectors = data;
                        this.sectorSlugs = this.sectors.map(a => a.slug);
                        if (sessionStorage.getItem("sector_innovation")) {
                            this.searchOptions.sector = sessionStorage.getItem("sector_innovation");
                        } else {
                            const pathArray = window.location.pathname.split('/');
                            if (pathArray[2]) {
                                this.searchOptions.sector = pathArray[2];
                            }
                        }
                    });
                }
            }
        },
        mounted() {

            let performanceTiming = performance.getEntriesByType('navigation')[0];
            if (performanceTiming.type === 'navigate') {
                sessionStorage.removeItem("sector_innovation");
                sessionStorage.removeItem("additionalSectors");
                sessionStorage.removeItem("benefits");
                sessionStorage.removeItem("countries");
                sessionStorage.removeItem("developmentStages");
                sessionStorage.removeItem("patentStatuses");
                sessionStorage.removeItem("geographicalAreas");
                sessionStorage.removeItem("companyTypes");
                sessionStorage.removeItem("investmentTypes");
                sessionStorage.removeItem("currencies");
            }

            this.searchOptions.search = this.getParameter('search');

            $(window).scroll(function () {
                sessionStorage.scrollPos = $(window).scrollTop();
            });
        },
        components: {
            'multiselect': Multiselect,
            InfiniteLoading
        },
    });
}